var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEspeciesEmblematicas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_especies_emblematicas",
    "data-name": "ico_especies emblematicas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_60",
    "data-name": "Rect\\xE1ngulo 60",
    width: 100,
    height: 100,
    fill: "#f2b229"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    "data-name": "Grupo 91",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_252",
    "data-name": "Trazado 252",
    d: "M78.669,90c-9.516-1.5-9.5-10.563-9.461-11.59-.2-3.9.91-6.933,3.3-9.031C76.5,65.877,82.915,66.1,85.761,66.4V61.2h-7.45a9.143,9.143,0,0,1-.936.093,5.717,5.717,0,0,0-.789.084,15.864,15.864,0,0,0-8.5,4.724,15.655,15.655,0,0,0-4.408,11.226c.04,8.207.032,16.55.025,24.618q0,5.075-.006,10.151v.1a1.863,1.863,0,0,0,.012.312.371.371,0,0,0,.045.125.418.418,0,0,0,.112.037,1.768,1.768,0,0,0,.314.013H78.669Z",
    transform: "translate(-37.841 -36.373)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_253",
    "data-name": "Trazado 253",
    d: "M124.087,68.859a1.776,1.776,0,0,0,.449,1.352c.536.437,1.737.408,3.295-.08a17.32,17.32,0,0,1,6.258-.575,12.208,12.208,0,0,1,5.844-8.173,13.559,13.559,0,0,0-1.56-.182H124.094Z",
    transform: "translate(-73.742 -36.372)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_254",
    "data-name": "Trazado 254",
    d: "M154.725,71.817a26.455,26.455,0,0,1,14.563,7.721V75.8l-.044-.387a11.264,11.264,0,0,0-.366-2.1,13.96,13.96,0,0,0-7.385-8.812,9.947,9.947,0,0,0-6.768,7.312",
    transform: "translate(-91.952 -38.335)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_255",
    "data-name": "Trazado 255",
    d: "M101.362,83.908a4.108,4.108,0,0,1-2.655-.868,4.013,4.013,0,0,1-1.319-3.218c-2.339-.271-8.269-.607-11.639,2.352-1.81,1.59-2.641,3.984-2.469,7.12l0,.075-.005.076a10.536,10.536,0,0,0,.867,4.429c1.278,2.855,3.8,4.469,7.487,4.8l1.11.1v24.881h8.268c.043,0,.084,0,.127,0a.281.281,0,0,0,.306-.2,1.982,1.982,0,0,0,.076-.738V94.246Zm-8.256,5.47c-.8,0-1.456-1.3-1.456-2.91s.652-2.911,1.456-2.911,1.456,1.3,1.456,2.911-.652,2.91-1.456,2.91",
    transform: "translate(-49.48 -47.336)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_256",
    "data-name": "Trazado 256",
    d: "M134.374,88.155c-.173.054-.336.094-.5.139L134,96.726h6.323q7.912,0,15.825,0a3.072,3.072,0,0,0,.488-.031c-6.392-8.123-16.926-10.208-22.26-8.539",
    transform: "translate(-79.558 -52.073)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_257",
    "data-name": "Trazado 257",
    d: "M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0M79.77,44.743l-.059.183a2.822,2.822,0,0,1-3.123,2.161q-7.914,0-15.826,0H54.473V75.358a3.929,3.929,0,0,1-.318,1.816,2.7,2.7,0,0,1-2.341,1.572c-.07,0-.14.006-.211.006H26.336a3.651,3.651,0,0,1-.841-.071,2.527,2.527,0,0,1-2.006-2,3.65,3.65,0,0,1-.072-.863v-.085q0-5.077.006-10.153c.007-8.065.015-16.4-.026-24.6A18.564,18.564,0,0,1,38.24,22.627a7.7,7.7,0,0,1,1.14-.132,6.166,6.166,0,0,0,.752-.076l.114-.022,24.487,0a13.525,13.525,0,0,1,4.044.793A16.606,16.606,0,0,1,79.249,34.256a13.265,13.265,0,0,1,.462,2.551l.059.589Z",
    transform: "translate(0 -0.001)",
    fill: "#f2b229"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEspeciesEmblematicas);
export default __webpack_public_path__ + "static/media/ico_especies_emblematicas.04dfc80643ff549485bfbeaef2eb590d.svg";
export { ForwardRef as ReactComponent };